import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { BankPortalService } from '../../../../web-api-client';

@Component({
  selector: 'app-merchants-deployment-information',
  templateUrl: './merchants-deployment-information.component.html',
  styleUrls: ['./merchants-deployment-information.component.css']
})
export class MerchantsDeploymentInformationComponent implements OnInit {
  @Input('deploymentRequestId') deploymentRequestId: any;
  // @Output() callBackOutput: EventEmitter<object> = new EventEmitter<object>();
  deploymentInfo: any;
  isTerminalClicked: boolean = false; 
  isDeploymentInfoNull: boolean = false;
  @Output('merchantDeploymentInfo')
  merchantDeploymentInfo: EventEmitter<boolean> = new EventEmitter<boolean>();
  constructor(
    private bankPortalService: BankPortalService,
    private _cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
  }
  loadDeploymentinfo() {
    this.bankPortalService.bankPortal_GetAllDeploymentInfo(this.deploymentRequestId).subscribe(
      res => 
      {
        if(res == null)
        {
          this.isDeploymentInfoNull = true;
          this.merchantDeploymentInfo.emit(this.isDeploymentInfoNull);
          return;
        }
        this.deploymentInfo = res;
        this.isTerminalClicked = true;
        this.connectivityType();
        this.isDeploymentInfoNull = false;
      },
      error => this.unSuccess(error));
  }

  unSuccess(error: any) {
    // this.notify.showError("Error", "Error !!");
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.deploymentRequestId && changes.deploymentRequestId) {
      this.loadDeploymentinfo();
      this._cdr.detectChanges();

    }
  }
  public connectivityType() 
  {
    let connectivityList = [
      { value: 1, option: 'ETHERNET' },
      { value: 2, option: 'GPRS' },
      { value: 3, option: 'PSTN' },
      { value: 4, option: 'UNKNOWN' },
      { value: 5, option: 'WIFI' }
    ]
    var idString = this.deploymentInfo?.connectivity.toString();
    let ids = idString?.split("|");
    ids = ids.map(x => +x);
    var temp = connectivityList.filter((f: { value: any; }) => ids.includes(f.value));
    var temp1 = temp.map(x => x.option).join(', ');
    this.deploymentInfo.connectivity = temp1;
  }

}
